import LabDataEntry from "../../pages/laboratory/data-entry";
import ChemistrySamplesPage from "../../pages/laboratory/chemistries-report";
import { RouteConfig } from "./types";

// Define Lab routes with flat structure
export const labRoutes: RouteConfig[] = [
  {
    path: "/lab-data-entry",
    element: <LabDataEntry />,
    permission: "ui.navbar.lab.data-entry",
  },
  {
    path: "/lab-data-entry/:processId",
    element: <LabDataEntry />,
    permission: "ui.navbar.lab.data-entry",
  },
  {
    path: "/lab-chemistry-samples",
    element: <ChemistrySamplesPage />,
    permission: "ui.navbar.lab.chemistry-samples",
  },
];
